export default __webpack_public_path__ + "static/media/peach_badge.2790ab15.svg";